import {
  Box,
  BoxProps,
  Flex,
  Image,
  Img,
  Text,
} from '@joinrepublic/dls-ui-kit';

import { GenericIcon } from '../asset/generic-icon';
import { Size, SIZE_STYLES } from './asset-icon.variants';

export interface IAssetIconProps {
  logoUrl?: string | null;
  chainLogoUrl?: string | null;
  size?: Size;
  logoProps?: BoxProps;
  tokenName?: string;
  fallbackStrategy?: 'onError' | 'beforeLoadOrError';
}

function getTokenInitials(name: string): string {
  const names = name.trim().split(' ');
  const firstName = names[0] ?? '';
  const lastName = names.length > 1 ? names[names.length - 1] : '';
  return firstName && lastName
    ? `${firstName.charAt(0)}${lastName.charAt(0)}`
    : firstName.charAt(0);
}

export function AssetIcon({
  logoUrl,
  chainLogoUrl,
  size = 'xs',
  logoProps,
  tokenName,
  fallbackStrategy = 'onError',
}: IAssetIconProps) {
  const {
    assetIcon: assetIconSize,
    chainIcon: chainIconSize,
    avatarSize,
  } = SIZE_STYLES[size];

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      {logoUrl || !tokenName ? (
        <Image
          bg={logoUrl ? 'white' : 'black'}
          borderRadius="full"
          src={logoUrl ?? undefined}
          alt={tokenName ? `${tokenName} logo` : 'asset logo'}
          fallback={
            <GenericIcon h={assetIconSize.height} w={assetIconSize.height} />
          }
          fallbackStrategy={fallbackStrategy}
          objectFit="contain"
          outline="1px solid"
          outlineColor="rgba(0, 0, 0, 0.1)"
          outlineOffset="-1px"
          {...assetIconSize}
          {...logoProps}
        />
      ) : (
        <Flex
          height={avatarSize}
          width={avatarSize}
          bg="grey.50"
          textColor="gray.800"
          outline="1px solid"
          outlineColor="rgba(0, 0, 0, 0.1)"
          outlineOffset="-1px"
          borderRadius="full"
          alignItems="center"
          justifyContent="center"
          textTransform="uppercase"
          aria-label={tokenName ? `${tokenName} logo` : 'asset logo'}
          role="img"
        >
          <Text>{getTokenInitials(tokenName)}</Text>
        </Flex>
      )}
      {chainLogoUrl ? (
        <Img
          alt="chain logo"
          position="absolute"
          borderRadius="full"
          borderWidth="2px"
          borderStyle="solid"
          borderColor="white"
          bg="white"
          outline="1px solid rgba(0, 0, 0, 0.1)"
          outlineOffset="-3px"
          bottom="-2px"
          right="-2px"
          src={chainLogoUrl ?? undefined}
          {...chainIconSize}
        />
      ) : null}
    </Box>
  );
}
